// src/App.jsx
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import CustomerHome from './pages/CustomerHome';
import OrderConfirmation from './pages/OrderConfirmation';
import MultiStepCakeOrderForm from './pages/cakeorderform/MultiStepCakeOrderForm';
import DownloadPDF from './pages/DownloadPDF';

import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import AllOrders from './pages/admin/AllOrders';
import Quotes from './pages/admin/Quotes';
import ManageSite from './pages/admin/ManageSite';
import Settings from './pages/admin/Settings';
import AcceptQuote from './pages/AcceptQuote';
import AcceptQuoteSuccess from './pages/AcceptQuoteSuccess';
import OrderRemainingPayment from './pages/OrderRemainingPayment';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentSuccess from './pages/PaymentSuccess';

// ⬇️ NEW: Gallery Admin page
import GalleryAdmin from './pages/admin/GalleryAdmin';

function App() {
  return (
    <Router>
      <Routes>
        {/* Customer Routes */}
        <Route path="/" element={<CustomerHome />} />
        <Route path="/order" element={<MultiStepCakeOrderForm />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/pdf" element={<DownloadPDF />} />
        <Route path="/quote/:token" element={<AcceptQuote />} />
        <Route path="/quote/:token/success" element={<AcceptQuoteSuccess />} />
        <Route path="/order/:token/pay" element={<OrderRemainingPayment />} />
        <Route
          path="/order/:token/payment-success"
          element={<PaymentSuccessPage />}
        />
        <Route path="/payment-success" element={<PaymentSuccess />} />





        {/* Admin Auth */}
        <Route path="/Taylor/login" element={<AdminLogin />} />

        {/* Admin Panel with Layout */}
        <Route path="/Taylor" element={<AdminLayout />}>
          <Route index element={<Navigate to="/Taylor/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="all-orders" element={<AllOrders />} />
          <Route path="quotes" element={<Quotes />} />
          <Route path="manage-site" element={<ManageSite />} />
          <Route path="settings" element={<Settings />} />

          {/* ⬇️ NEW: Gallery Manager route */}
          <Route path="gallery" element={<GalleryAdmin />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
